import { JSONSchemaType } from 'ajv'

export interface IPaymentGatewayFormData {
  name: string
  gatewayId: string
  subscriptionId: string
  apiKey: string
  apiSecret: string
  isInactive: boolean
}

const PaymentGatewaySchema: JSONSchemaType<IPaymentGatewayFormData> = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    gatewayId: {
      type: 'string',
    },
    subscriptionId: {
      type: 'string',
    },
    apiKey: {
      type: 'string',
    },
    apiSecret: {
      type: 'string',
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['name'],
  additionalProperties: false,
}

export default PaymentGatewaySchema
